export const environment = {
  USEndpoint: 'https://api-qa.tetherall.io/client/',
  CAEndpoint: 'https://api-qa.tetherall.io/client/',
  buildNumber: "29895764",  
  versionNumber: "5.4.11",  
  environment_deploy: 'qa',
  raygunApiKey: '19Ef2ju2ppmbEe8xOPBOA',
  posthogToken: 'phc_PuEnTqZCSS7VliKtYiAbPisu6SDBFXEfIzbqbnuYPMg',
  authResultKey: 'c8c46f55-3ce8-40d1-83c5-8838e1b29ae5',
  biometricsEmailKey: 'b0a0d9f2-afc6-447e-ae2a-f1fcabe42276',
  rememberEmailKey: 'f78ed40d-0f45-4c53-95dd-3e985bead3a8',
  vaultKey: 'fb511dcc-c1c2-4aee-8194-f0abbeadccce',
  loginKey: 'daec5860-165c-4f10-9e04-c610b0f05454',
  cryptoKey: 'e76c6e0d-7c2a-454f-81fa-e6165096d7ab',
};
